<template>
  <div id="rotate-message-container">
    <div class="login-logo"></div>
    <div class="flex-row align-items-center gap-md mb-md">
      <dd-icon icon="mdi mdi-phone-rotate-landscape" size="xl" class="color-primary"/>
      <h1 class="m-0">Draai je apparaat</h1>
    </div>
    <p>Dossierdata werkt het beste in landschapmodus. Draai alsjeblieft je apparaat om verder te gaan.</p>
  </div>
</template>

<script>
export default {
  name: "RotateToLandscapeMessageComponent"
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

#rotate-message-container{
  display: none; // hide by default
  position: fixed;
  inset: 0;
  z-index: 99999999;
  background: linear-gradient(45deg, #e9ebf1 0, #fff 100%);
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .login-logo{
    height: 100px;
    width: 100px;
    margin-bottom: $spacing-xl;

    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: $login-branding-logo;
  }
}

@media screen and (orientation: portrait) and (max-height: $screen-lg-min) {
  #rotate-message-container{
    display: flex !important;
  }
}
</style>